import moment from 'moment';
import React from 'react';
import { Form, Header, Icon, Popup, Table } from 'semantic-ui-react';

import { Resultados } from 'src/api';

export type Props = Readonly<{
    atenciones: Readonly<Resultados<'atencionesPsicopedagogiaDeFecha'>>;
    mapaAlumnos: Map<number, string>;
    fechaDeAtenciones: string;
    cargandoAtenciones: boolean;
    alEliminar: (idAtencion: string) => void;
    alSolicitarAtenciones: (idAtencion: string) => void;
}>;

export const TablaDeAtenciones = (props: Props) => {
    const {
        atenciones,
        mapaAlumnos,
        alEliminar,
        fechaDeAtenciones,
        alSolicitarAtenciones,
        cargandoAtenciones,
    } = props;

    if (cargandoAtenciones) {
        return <Icon loading />;
    }

    return (
        <div>
            <Header as='h2' content='Lista de atenciones' />

            <Form>
                <Form.Input
                    label='Fecha'
                    required
                    type='date'
                    value={fechaDeAtenciones}
                    onChange={(_, { value }) => alSolicitarAtenciones(value)}
                    width='4'
                />
            </Form>
            <Table collapsing compact>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Alumno' width='7' />
                        <Table.HeaderCell content='Fecha' width='2' />
                        <Table.HeaderCell content='Hora' width='2' />
                        <Table.HeaderCell content='' width='3' />
                        <Table.HeaderCell width='1' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {atenciones.map(atencion => (
                        <Table.Row
                            key={atencion.idAtencion}
                            warning={atencion.tipoDeAtencion === 'excepcional'}
                            negative={atencion.tipoDeAtencion === 'ausente'}
                        >
                            <Table.Cell content={mapaAlumnos.get(atencion.numeroDeMatricula)} />

                            <Table.Cell
                                content={moment(Fecha(atencion.fechaYHora)).format('DD-MM-YYYY')}
                            />
                            <Table.Cell content={Hora(atencion.fechaYHora)} />
                            <Table.Cell
                                textAlign='left'
                                content={mapaEstadoDeAtencion[atencion.tipoDeAtencion]}
                            />
                            <Table.Cell>
                                <Popup
                                    trigger={
                                        <Icon
                                            circular
                                            link
                                            name='close'
                                            onClick={() => alEliminar(atencion.idAtencion)}
                                        />
                                    }
                                    content='Eliminar'
                                    inverted
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

const mapaEstadoDeAtencion: Record<string, string> = {
    normal: '',
    ausente: 'Ausente',
    excepcional: 'Excepcional',
};

const caracteresAntesDeT = /[^T]*/;

const caracteresDespuesDeT = /[^T]*$/;

function Fecha(fechaYHora: string) {
    return String(fechaYHora.match(caracteresAntesDeT));
}

function Hora(fechaYHora: string) {
    return String(fechaYHora.match(caracteresDespuesDeT));
}



// WEBPACK FOOTER //
// ./src/modulos/Psicopedagogia/componentes/TablaDeAtenciones.tsx